import { Builder } from '@builder.io/react';

import TextSpinner from './text-spinner';

Builder.registerComponent(TextSpinner, {
  name: 'TextSpinner',
  inputs: [
    {
      name: 'overline',
      type: 'text'
    },
    {
      name: 'underline',
      type: 'text'
    },
    {
      name: 'phrases',
      helperText: 'expects array of 6 phrases',
      type: 'list',
      defaultValue: [{ name: 'label' }],
      subFields: [
        {
          name: 'name',
          type: 'string'
        }
      ]
    },
    {
      name: 'ctaText',
      type: 'text'
    },
    {
      name: 'ctaLink',
      type: 'url'
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          defaultValue: [
            {
              text: 'Get Started',
              href: '/sales',
              type: 'primary'
            }
          ],
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'type',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary']
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'default',
              enum: ['default', 'transparent']
            }
          ]
        },
        {
          name: 'hubspotModal',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'hubspotModal',
          type: 'object',
          showIf: `options.get('hubspotModal')`,
          subFields: [
            {
              name: 'formId',
              type: 'string'
            },
            {
              name: 'sfdcCampaignId',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            },
            {
              name: 'type',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary']
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'default',
              enum: ['default', 'transparent']
            }
          ]
        }
      ]
    }
  ]
});
